import { ref } from 'vue'

// ADR-086: địa chỉ web Q One Document dùng chung đăng nhập (từ /system-settings/public); null = không tích hợp.
const webBaseUrl = ref<string | null>(null)

export function setQOneDocumentWebUrl(value: string | null | undefined) {
  webBaseUrl.value = typeof value === 'string' && /^https?:\/\//i.test(value) ? value.replace(/\/+$/, '') : null
}

/** Trang chi tiết tài liệu trên QOD (`/documents/d/:documentId`); null khi chưa cấu hình hoặc chưa có Id. */
export function qoneDocumentUrl(documentId: string | null | undefined): string | null {
  return webBaseUrl.value && documentId ? `${webBaseUrl.value}/documents/d/${encodeURIComponent(documentId)}` : null
}
